import { FC } from 'react';
import { IPageContent } from '@/common/api/cms';
import { IPageWithContentComponent } from '@/common/interfaces';
import PageDescription from '../../components/cms/PageDescription';
import { getBgImageStyle } from '@/common/styles';
import { InstructorsList } from '@/components/instructors/InstructorsList';

export interface IInstructorDescription {
  id: number;
  description: string;
  image_url: string;
  instructor: {
    name: string;
    languages: string[] | null;
    training_programs: {
      id: string;
      icon?: string;
      title: string;
      // short version of title
      training_type: string;
    }[];
  };
}

export interface IInstructorsPageContent extends IPageContent {
  instructors_descriptions: IInstructorDescription[];
}

export const InstructorsPage: FC<IPageWithContentComponent<IInstructorsPageContent>> = ({
  content,
}) => {
  return (
    <div
      style={getBgImageStyle(content.background_image_url)}
      className="flex flex-1 bg-no-repeat bg-cover"
    >
      <div className="flex flex-1 overflow-y-auto">
        <div
          className="container mx-auto w-full h-max backdrop-blur-xs justify-start min-h-full text-white flex items-center py-10"
          data-testid="who-are-we-container"
        >
          <div className="flex flex-col gap-5 bg-training-details py-10 px-16">
            <PageDescription pageContent={content} paragraphClassname="leading-[1.8]" />
            <InstructorsList instructors={content.instructors_descriptions} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstructorsPage;
